import req from "@/assets/js/axios"
export default {
     // 课程列表
	 getFrontColleges: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/CollegeController/getFrontColleges', params)
      },
    // 获取热门课程
    getHotColleges: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/CollegeController/getHotColleges', params)
    },
    // 获取热门讲师
    getHotLecturer: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/CollegeController/getHotLecturer', params)
    },
    // 推荐课程
    getRecommendClass: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/CollegeController/getRecommend', params)
    },
    // 学院课程报名
    schoolClassSignUp: (params) => {
		return req.apiAxios("POST", '/sctccHost/order/OrderController/createOrder', params)
    },
    // 小测列表
    getFontExam: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/exam/COExamController/getFontExam', params)
    },
    // 小测列表
    checkExam: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/exam/COExamController/getFontExam', params)
    },
    // 小测提交
    getFontExam: (params) => {
		return req.apiAxios("POST", '/sctccHost/business/exam/BCOExamController/checkExam', params)
    },
    // 更新课程进度method, url, params, Deal,config,isLoad
    updateFontSchedule: (params,isLoad) => {
		return req.apiAxios("POST", '/sctccHost/college/schedule/COScheduleController/updateFontSchedule', params,false,null,isLoad)
    },
    // 购买，取消订单，付款等课程操作
    submitCOOrder: (params) => {
		return req.apiAxios("POST", '/sctccHost/business/order/BOrderController/submitCOOrder', params)
    },
    // 新支付接口
    pay: (params) => {
		return req.apiAxios("POST", '/sctccHost/business/order/BOrderController/pay', params)
    },
    // 查询已购买课程
    getFrontCOExtends: (params) => {
		return req.apiAxios("POST", '/sctccHost/business/order/BOrderController/getStatus', params)
    },
     // 查询支付状态
     getPayStatus: (params) => {
		return req.apiAxios("POST", '/sctccHost/college/extend/COExtendController/getFrontCOExtends', params)
    },
     // 删除订单
     deleteSchoolOrder: (params) => {
		return req.apiAxios("POST", '/sctccHost/business/order/BOrderController/deleteOrder', params)
    },
     // 条件查询订单（前台）
     getOrders: (params) => {
      return req.apiAxios("POST", '/sctccHost/order/OrderController/getOrders', params)
      },
}
